import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import { billingHistory } from 'src/features/Settings/utils/constants';

export const BillingTab: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch" maxWidth={'960px'}>
      {/* Subscription Plan Section */}
      <Box
        p={6}
        bg="surface.sidebarMuted"
        borderRadius="16px"
        border="1px"
        borderColor="surface.border">
        <HStack justify="space-between" align="flex-start" mb={4}>
          <HStack spacing={3} align="center">
            <Text fontSize="lg" fontWeight="bold" color="content.title">
              DIGITAL START
            </Text>
            <Badge
              bg="background.lightGreen"
              color="icon.green"
              px={3}
              py={1}
              borderRadius="full"
              textTransform="none"
              fontFamily="marketingPage"
              fontSize="xs">
              Current
            </Badge>
          </HStack>
          <Button
            bg="icon.green"
            color="white"
            size="md"
            minWidth={'156px'}
            px={3}
            py={2}
            borderRadius="md"
            fontWeight="600"
            buttonName="upgrade-plan"
            fontFamily="marketingPage"
            _hover={{ bg: 'green.500' }}>
            Upgrade Plan
          </Button>
        </HStack>

        <Text fontSize="sm" color="content.muted" mb={2}>
          Lorem ipsum dolor sit amet consectetur.
        </Text>

        <HStack spacing={1} align="baseline">
          <Text fontSize="2xl" fontWeight="bold" color="content.title">
            $890.00
          </Text>
          <Text fontSize="lg" color="content.title">
            /Month
          </Text>
        </HStack>
      </Box>

      {/* Payment Method Section */}
      <Box
        p={6}
        bg="surface.panel"
        borderRadius="16px"
        border="1px"
        borderColor="surface.border">
        <HStack justify="space-between" align="flex-start" mb={4}>
          <Text fontSize="lg" fontWeight="bold" color="content.title">
            PAYMENT METHOD
          </Text>
          <Button
            variant="outline"
            borderColor="icon.green"
            color="content.title"
            size="md"
            px={3}
            py={2}
            borderRadius="md"
            fontWeight="semibold"
            fontFamily="marketingPage"
            buttonName="update-payment-method"
            _hover={{ bg: 'border.lightGreen' }}>
            Update Method
          </Button>
        </HStack>

        <Box p={4} bg="surface.sidebarMuted" borderRadius="16px">
          <HStack spacing={3}>
            <Icon iconName="credit-card" boxSize={6} color="content.muted" />
            <VStack align="flex-start" spacing={0}>
              <Text fontSize="md" color="content.title">
                Visa ending in 4242
              </Text>
              <Text fontSize="sm" color="content.muted">
                Expires 09/2025
              </Text>
            </VStack>
          </HStack>
        </Box>
      </Box>

      {/* Billing History Section */}
      <Box
        p={6}
        bg="surface.panel"
        borderRadius="16px"
        border="1px"
        borderColor="surface.border">
        <Text fontSize="lg" fontWeight="bold" color="content.title" mb={4}>
          BILLING HISTORY
        </Text>

        <Box maxHeight="400px" overflowY="auto">
          <Table variant="simple">
            <Thead height="60px">
              <Tr
                bg="surface.sidebarMuted"
                borderBottom="1px"
                borderColor="surface.border"
                borderTopLeftRadius="16px"
                borderTopRightRadius="16px">
                <Th
                  color="content.label"
                  fontWeight="semibold"
                  fontSize="sm"
                  px={4}
                  verticalAlign="middle">
                  Date
                </Th>
                <Th
                  color="content.label"
                  fontWeight="semibold"
                  fontSize="sm"
                  px={4}
                  verticalAlign="middle">
                  Description
                </Th>
                <Th
                  color="content.label"
                  fontWeight="semibold"
                  fontSize="sm"
                  px={4}
                  verticalAlign="middle">
                  Amount
                </Th>
                <Th
                  color="content.label"
                  fontWeight="semibold"
                  fontSize="sm"
                  px={4}
                  verticalAlign="middle">
                  Status
                </Th>
                <Th
                  color="content.label"
                  fontWeight="semibold"
                  fontSize="sm"
                  px={4}
                  verticalAlign="middle">
                  Invoice
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {billingHistory.map((item, index) => (
                <Tr key={index} borderBottom="1px" borderColor="surface.border">
                  <Td fontSize="md" color="content.title" px={4}>
                    {item.date}
                  </Td>
                  <Td fontSize="md" color="content.title" px={4}>
                    {item.description}
                  </Td>
                  <Td fontSize="md" color="content.title" px={4}>
                    {item.amount}
                  </Td>
                  <Td px={4}>{item.status}</Td>
                  <Td textAlign="center" px={4}>
                    <Icon
                      iconName="download"
                      boxSize={4}
                      color="content.muted"
                      cursor="pointer"
                      _hover={{ color: 'icon.green' }}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Box>
    </VStack>
  );
};
